import integration from '@sport/integration';
import { isIframeTurkeyHost } from '../../hostsConfig';
import Logo from '../Logo/Logo';

function Footer({currentTheme, refresh = () => {}}) {

  const onClick = (path) => {
    if (path) {
      integration.emit({ path }, 'iframe-navigation');
    }
  };

  return (
    <footer className={`${isIframeTurkeyHost ? 'turkey' : ''}`}>
      <div class="footer-container">
        <div class="footer-column">
          <h3>About Us</h3>
          <p>
            We are committed to delivering the best services and creating
            meaningful digital experiences for our clients.
          </p>
        </div>
        <div className="footer-column">
          <h3>Quick Links</h3>
          <ul>
            <li>
              <a href="#about">About</a>
            </li>
            <li>
              <a href="#services">Services</a>
            </li>
            <li>
              <a href="#contact">Contact</a>
            </li>
            <li>
              <a href="#faq">FAQ</a>
            </li>
          </ul>
        </div>
        <div className="footer-column">
          <h3>Sports</h3>
          <ul>
            <li>
              <a
                href="/all-live"
                onClick={(e) => {
                  e.preventDefault();
                  onClick('/all-live');
                }}
              >
                  All live
                </a>
            </li>
            <li>
              <a
                href="/football/live"
                onClick={(e) => {
                  e.preventDefault();
                  onClick('/football/live');
                }}
              >
                Football
              </a>
            </li>
            <li>
              <a
                href="/basketball"
                onClick={(e) => {
                  e.preventDefault();
                  onClick('/basketball/live');
                }}
              >
                  Basketball
              </a>
            </li>
            <li>
              <a
                href="/top-express"
                onClick={(e) => {
                  e.preventDefault();
                  onClick('/top-express');
                }}
              >
                Top Express
              </a>
            </li>
          </ul>
        </div>
        <div className="footer-logo">
          <Logo currentTheme={currentTheme} refresh={refresh} />
          <p>&copy; 2026 {!isIframeTurkeyHost && <span>GR8 Tech. </span>}All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer;